import { useTranslation } from 'react-i18next';
import { BannerContainer, ButtonContainer, DemoButtonLink, Image, InfoContainer, TextContainer } from './BannerComponents';
import img from "./Image.png";

function Banner() {
  const { t } = useTranslation();

  return (
    <>
       <BannerContainer>
        <InfoContainer>
          <TextContainer>
            <h1>{t('banner.title')}</h1>
            <h5>{t('banner.subtitle')}</h5>
          </TextContainer>
          <ButtonContainer>
            <DemoButtonLink as="a" href="#contactSection">{t('banner.demo')}</DemoButtonLink>
          </ButtonContainer>
      </InfoContainer>
      <Image src={img} alt="Banner illustration" />
    </BannerContainer>

    </>
  );
}
export default Banner;